export default __webpack_public_path__ + "static/elysian_island_forgery-8f9e07609978fadb5844491b8aade0f7.png";